import CircleBloodPact from "./CircleBloodPact";

export default CircleBloodPact;